import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from "../../services/server";
import "./css/login.css";

const MODULE_LABELS = {
  valuation: "Valuation",
  dataroom:  "Data room",
  dd:        "Due diligence",
  im:        "Information memorandum",
};

export default function AcceptBuyerInvite() {
  const { token } = useParams();
  const navigate   = useNavigate();

  const [info,        setInfo]        = useState(null);
  const [password,    setPassword]    = useState("");
  const [confirm,     setConfirm]     = useState("");
  const [error,       setError]       = useState("");
  const [submitting,  setSubmitting]  = useState(false);
  const [done,        setDone]        = useState(false);
  const [workspaceKey, setWorkspaceKey] = useState("");

  useEffect(() => {
    fetch(`${API_BASE}/users/buyer-invitations/${token}/`)
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.detail || "Invalid or expired invitation.");
        }
        return res.json();
      })
      .then(setInfo)
      .catch((err) => setError(err.message));
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/users/buyer-invitations/${token}/`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || "Something went wrong.");
      setWorkspaceKey(data.workspace_key || "");
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <h1>Account activated</h1>
          <p style={{ marginBottom: 20 }}>
            Your buyer account is ready. Log in to access the workspace.
          </p>
          <button
            className="login-button"
            onClick={() => navigate(workspaceKey ? `/buyer/${workspaceKey}` : "/login")}
          >
            {workspaceKey ? "Go to buyer portal" : "Go to login"}
          </button>
        </div>
      </div>
    );
  }

  if (error && !info) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <h1>Invalid invitation</h1>
          <p style={{ color: "red" }}>{error}</p>
        </div>
      </div>
    );
  }

  if (!info) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <p>Loading…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Buyer portal access</h1>
        <p style={{ marginBottom: 4, color: "#4b5563" }}>
          You have been invited to review materials for{" "}
          <strong>{info.workspace_name}</strong> as{" "}
          <strong>{info.buyer_company_name}</strong>.
        </p>
        {info.modules && info.modules.length > 0 && (
          <p style={{ marginBottom: 16, color: "#6b7280", fontSize: 13 }}>
            Access:{" "}
            {info.modules.map((m) => MODULE_LABELS[m] || m).join(", ")}
          </p>
        )}

        <div className="login-field">
          <label>Email</label>
          <input value={info.email} disabled />
        </div>

        <div className="login-field">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </div>

        <div className="login-field">
          <label>Confirm password</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>

        {error && <p style={{ color: "red", margin: "8px 0" }}>{error}</p>}

        <button className="login-button" disabled={submitting}>
          {submitting ? "Activating…" : "Activate account"}
        </button>
      </form>
    </div>
  );
}
